import React from 'react';

export function Loading() {
  return (
    <div className="w-full h-screen flex justify-center items-center">
      <img src="assets/loading.gif" className="w-8 h-8" alt="" />
    </div>
  );
}
